export const PositionBoxLayer = {
    Margins: 'margins',
    Paddings: 'paddings',
};
//# sourceMappingURL=positionBox.js.map